<template>
  <div>
    <b-btn block variant="danger" class="font-weight-bold" @click="openRefund">
      Refund
      <span v-if="$showApprove([3, 4, 5, 9, 11, 12])">
        *
      </span>
    </b-btn>
    <approve-permission
      :orderId="orderId"
      :tab-no="order.TabNo"
      action-type="Refund"
      @acceptPermission="openWithAcceptPermission"
      v-model="approveModal"
    />
    <c-modal
      v-model="modal"
      cancel-label="No, Never mind"
      centered
      title="Confirm refund"
      :tag="false"
      confirm-label="Process with Refund"
      :progressing="progressing"
      size="md"
      @submit="startRefund"
    >
      <template>
        <b-form-group>
          <b-form-radio class="my-3" v-model="refundType" name="some-radios" value="FullRefund">Full refund</b-form-radio>
          <b-form-radio class="my-3" v-model="refundType" name="some-radios" value="PartialRefund">Partial refund</b-form-radio>
        </b-form-group>
        <section>
          <div>
            <div class="h4 mb-3">
              Reason for Refund:
            </div>
            <b-form-group v-slot="{ariaDescribedby}">
              <b-form-radio-group
                size="lg"
                id="refundReasons"
                v-model="RefundReason"
                :aria-describedby="ariaDescribedby"
                name="Reason"
                v-validate="'required'"
              >
                <b-form-radio style="margin-bottom: 20px" value="Promotions">Promotions</b-form-radio>
                <b-form-radio style="margin-bottom: 20px" value="Guest Relations">Guest Relations</b-form-radio>
                <b-form-radio style="margin-bottom: 20px" value="Staff Meals">Staff Meals</b-form-radio>
                <b-form-radio style="margin-bottom: 20px" value="Owner Meals">Owner Meals</b-form-radio>
                <b-form-radio style="margin-bottom: 20px" value="Cash (No-Penny) Rounding">Cash (No-Penny) Rounding</b-form-radio>
                <b-form-radio style="margin-bottom: 20px" value="Other">Other</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </section>
       

        <b-form-group v-if="refundType === 'PartialRefund'">
          <b-input-group prepend="Refund Amount ($)">
            <b-input
              type="number"
              v-validate="'required|min_value:1|max_value:' + (order.Total - order.Fee).toFixed(2)"
              v-model="refundValue"
              name="Refund Amount"
            />
          </b-input-group>
        </b-form-group>
        <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
          <ul class="m-0 px-1">
            <li v-for="err in errors.all()" :key="err">{{ err }}</li>
          </ul>
        </b-alert>
      </template>
    </c-modal>
    <c-modal
      v-model="showOptions"
      centered
      title="Post Refund Confirmation"
      :tag="false"
      size="lg"
      @submit="refundAndCancelTab"
      @reject="keepOrderOpen"
    >
      <template>
        <div class="pb-0">
          <h5 class="text-center">what would you like to do with this order after refund?</h5>
          <div class="p-1 d-flex flex-row justify-content-between align-items-center" style="gap: 1rem; margin-top: 3rem;margin-bottom: -2rem !important;">
            <p  class="ml-4 mb-0"> Cancel Order to void the order and remove it </p>
            <p class="mb-0"> Keep Order Open if customer paying by another method</p>
          </div>
        </div>
      </template>
      <template #actions="{ submit: emitSubmit, reject: emitReject }">
        <b-row class="flex-grow-1">
          <b-col cols="6">
            <b-btn variant="warning" block class="text-nowrap" @click="emitSubmit">
              Cancel Order
            </b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn variant="warning" block class="text-nowrap" @click="emitReject">
              Keep Order Open
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </c-modal>
  </div>
</template>

<script>
import CModal from './Cmodal'
import ApprovePermission from './approvePermission'
export default {
  name: 'refundTab',
  components: {ApprovePermission, CModal},
  props: {
    orderId: {required: true, type: [String, Number]},
    TabNo: {type: [String, Number], default: ''},
    order: {type: Object, default: () => ({})},
    credit: {required: true},
    paymentStatus: {
      required: true
    }
  },
  data() {
    return {
      modal: false,
      progressing: false,
      refundType: 'FullRefund',
      refundValue: null,
      refundReason: null,
      approveModal: false,
      showOptions: false,
      RefundReason: null,
    }
  },
  watch: {
    modal(val) {
      if (!val) {
        this.$validator.reset()
      }
    }
  },
  methods: {
    openRefund() {
      if (this.$showApprove([3, 4, 5, 9, 11, 12])) {
        this.approveModal = true
      } else {
        this.modal = true
      }
    },
    openWithAcceptPermission() {
      this.approveModal = false
      this.modal = true
    },
    startRefund() {
      if (this.refundType === 'FullRefund') {
        this.$validator.validateAll().then(proceed => {
          if (proceed) {
            this.showOptions = true
          }
        })
      }else{
        this.$validator.validateAll().then(proceed => {
          if (proceed) {
            if (this.paymentStatus === 4 || this.paymentStatus >= 5) {
              this.refundCashPartial()
            } else{
              this.refundPartial()
            }
          }
        })
      }
    },
    keepOrderOpen() {
      this.showOptions = false
      this.refundTab()
    },
    refundAndCancelTab() {
      this.showOptions = false
      this.refundTab(true)

    },
    refundTab(cancel = false) {
      if (this.refundType === 'FullRefund') {
        this.$validator.validateAll().then(proceed => {
          if (proceed) {
            if (this.paymentStatus === 4 || this.paymentStatus >= 5) {
              this.refundCash(cancel)
            } else{
              this.refundNormal(cancel)
            }
          }
        })
      } else {
        this.$validator.validateAll().then(proceed => {
            if (proceed) {
                if (this.paymentStatus === 4 || this.paymentStatus >= 5) {
                    this.refundCashPartial(cancel)
                } else {
                    this.refundPartial(cancel)
                }
            }
        })
      }
    },
    refundCashPartial(cancel = false) {
      let object = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            UserID: localStorage.getItem('userID'),
            OrderID: this.orderId,
            Credit: this.refundValue,
            Reason: this.RefundReason
        }
      this.progressing = true
      this.$api.getRestaurant.RefundOrder_Cash(object).then(res => {
            if (res.success) {
              if (cancel) {
                this.cancelOrder()
              }else{
                this.refundValue = null
                this.modal = false
                this.progressing = false
                this.refundType = 'FullRefund'
                this.$emit('refresh')
              }
            } else {
                this.$showError(res.message)
                this.progressing = false
            }
        }).catch(() => {
            this.progressing = false
        })
    },
    refundCash(cancel = false) {
      let model = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.orderId,
              Credit: this.credit,
              Reason: this.RefundReason
            }
      this.progressing = true
      this.$api.getRestaurant.RefundOrder_Cash(model).then(res => {
        if (res.success) {
          
          this.$emit('refresh')
          if (cancel) {
            this.cancelOrder()
          }else{
            this.modal = false
            this.progressing = false
          }
        
        } else {
          this.$showError(res.message)
          this.progressing = false
        }
      }).catch(() => {
        this.progressing = false
      })
    },
    refundPartial(cancel = false) {
      let object = {
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        UserID: localStorage.getItem('userID'),
                        OrderID: this.orderId,
                        Credit: this.refundValue,
                        Reason: this.RefundReason
                    }
      this.progressing = true
      this.$api.getRestaurant.RefundOrder(object).then(res => {
                        if (res.success) {
                            
                            if (cancel) {
                              this.cancelOrder()
                            }else{
                              this.refundValue = null
                              this.modal = false
                              this.progressing = false
                              this.refundType = 'FullRefund'
                              this.$emit('refresh')
                            }
                        } else {
                            this.$showError(res.message)
                            this.progressing = false
                        }
                    }).catch(() => {
                        this.progressing = false
                    })
    },
    refundNormal(cancel = false) {
      let model = {
              RestaurantID: this.$store.state.selectedRestaurantId,
              // UserID: localStorage.getItem('userID'),
              OrderID: this.orderId,
              Credit: this.credit,
              Reason: this.RefundReason
            }
      this.progressing = true
      this.$api.getRestaurant.RefundOrder(model).then(res => {
        if (res.success) {
          
          this.$emit('refresh')
          if (cancel) {
                this.cancelOrder()
          }else{
            this.modal = false
            this.progressing = false
          }
        } else {
          this.$showError(res.message)
          this.progressing = false
        }
      }).catch(() => {
        this.progressing = false
      })
    },
    cancelOrder() {
      let object = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        // UserID: localStorage.getItem('userID'),
        OrderID: this.order.OrderID,
        OrderStatusID: 5,
        CancelReason: "Refunded and Canceled"
      }
      this.progressing = true
      this.$api.getRestaurant
        .UpdateOrderStatus(object)
        .then(res => {
          if (res.success) {
            this.$emit('refresh')
            this.modal = false
          } else {
            this.$showError(res.message)
          }
          this.progressing = false
        })
        .catch(() => {
          this.progressing = false
        })
    }
  }
}
</script>

<style scoped></style>
